import React from 'react';
    import { motion, AnimatePresence } from 'framer-motion';
    import SafeIcon from '../common/SafeIcon';
    import * as FiIcons from 'react-icons/fi';

    const { FiSearch, FiX } = FiIcons;

    const SearchBar = ({ searchQuery, setSearchQuery, selectedTags, onTagRemove }) => {
      return (
        <div className="max-w-2xl mx-auto">
          <div className="relative">
            <SafeIcon icon={FiSearch} className="absolute left-4 top-1/2 transform -translate-y-1/2 text-slate-400 text-xl" />
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Search by name, handle, or tag..."
              className="w-full pl-12 pr-4 py-4 text-lg border border-slate-300 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-slate-900 focus:border-slate-900 transition"
            />
          </div>
          {selectedTags.length > 0 && (
            <div className="flex flex-wrap gap-2 mt-4">
              {selectedTags.map((tag) => (
                <motion.span
                  key={tag}
                  layout
                  initial={{ opacity: 0, scale: 0.8 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0, scale: 0.8 }}
                  className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-slate-200 text-slate-800"
                >
                  {tag}
                  <button onClick={() => onTagRemove(tag)} className="ml-2 text-slate-500 hover:text-slate-800">
                    <SafeIcon icon={FiX} className="text-xs" />
                  </button>
                </motion.span>
              ))}
            </div>
          )}
        </div>
      );
    };

    export default SearchBar;